
import { defineComponent, inject, Ref, ref} from 'vue'
import ButtonSave from '@/components/buttons/ButtonSave.vue'
import ButtonClose from '@/components/buttons/ButtonClose.vue'
import { Job } from '@/@types/props'
import { applyToJob } from '@/store/data-sources/job'
import { FocusTrap } from 'focus-trap-vue'

export default defineComponent({
  setup() {
    return {
      active: ref(false),
      job: inject('job') as Ref<Job>,
      saved: ref(false),
      loading: ref(false),
    }
  },

  components: {
    ButtonSave,
    ButtonClose,
    FocusTrap
  },

  methods: {
    open() {
      this.active = true
    },

    async onApply() {
      this.loading = true

      await applyToJob(this.job.slug);

      this.loading = false
      this.saved = true
    },

    onCompleted() {
      this.active = false
    },

    onClose() {
      this.active = false
    }
  }
})
